export const orVideoHeroMockData = {
  description:
    'Our turnkey process, customizable home plans and transparent pricing ensure that you can build (and afford!) the home you’ve always imagined.',
  image: {
    alt: 'Alt text for hero image',
    src: {
      mobile: '/assets/image_card.jpg',
      tablet: '/assets/image_card.jpg',
      desktop: '/assets/image_card.jpg',
    },
  },
  videoUrl:
    'https://assets.contentstack.io/v3/assets/blte8e7d2bd4f946026/blt41bc96b7d7c4b9a1/67bc8fc801bc3b80279d1bba/sh-stock-vid.mp4',
  title: "Let's build your dream home",
};
